import { hotRank } from "@/mocks/homeNews";

export default function HotRank() {
  return (
    <section className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3 md:px-5">
        <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          <span className="flex h-6 w-6 items-center justify-center rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-fire-fill text-sm" />
          </span>
          24小时热榜
        </h3>
        <span className="whitespace-nowrap text-xs text-foreground-500">每 15 分钟刷新</span>
      </div>
      <ol className="divide-y divide-background-200/70">
        {hotRank.map((it) => (
          <li key={it.rank}>
            <a href="#today" className="flex items-start gap-3 px-4 py-3 transition hover:bg-secondary-100/60 md:px-5">
              <span
                className={
                  "flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-bold " +
                  (it.rank <= 3
                    ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                    : "bg-secondary-100 text-foreground-600")
                }
              >
                {it.rank}
              </span>
              <span className="flex min-w-0 flex-1 flex-col gap-1">
                <span className="line-clamp-2 text-sm leading-snug text-foreground-800">{it.title}</span>
                <span className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line" /> {it.views}
                  <span className="text-foreground-300">·</span>
                  <i className={it.trend === "up" ? "ri-arrow-up-line text-primary-500" : "ri-arrow-down-line text-accent-600"} />
                </span>
              </span>
            </a>
          </li>
        ))}
      </ol>
      <div className="border-t border-background-200 px-4 py-3 md:px-5">
        <a
          href="#today"
          className="flex items-center justify-center gap-1 rounded-full border border-background-300 py-2 text-sm text-foreground-600 transition hover:border-primary-400 hover:text-primary-600"
        >
          查看更多瓜事 <i className="ri-arrow-right-line" />
        </a>
      </div>
    </section>
  );
}